import type { RopWindowSource } from '@api/replenishment-planning';

/**
 * The reorder-window editor's constants and option-building, kept out of the component file
 * for the same reason `grouping.ts` and `explosion.ts` are: exporting non-components alongside
 * a component trips react-refresh/only-export-components.
 */

/**
 * The windows the rate ladder is PREFETCHED for. Not a menu — the editor takes any number —
 * but these are the reads a brand actually reasons in (a week, a fortnight, a month, a
 * quarter, a season), so fetching them up front means the common edit previews instantly
 * instead of waiting on a round trip. Anything hand-typed is fetched on demand.
 */
export const ROP_WINDOW_PRESETS = [7, 14, 30, 60, 90] as const;

export const ROP_SOURCE_TOOLTIP: Record<RopWindowSource, string> = {
    SKU: 'Set on this SKU — overrides the tier rule and the merchant default',
    TIER: "From this SKU's tier reorder rule",
    CONFIG_DEFAULT: 'The merchant default for replenishment',
    ORG_FALLBACK: "Inherited from the organisation's sales lookback — nothing set here yet",
    COVERAGE:
        'On a forecast basis: the days the order has to cover (lead time + safety). No lookback applies',
};
